<template>
    <div class="d-flex flex-column align-center">
        <div class="d-flex justify-center ml-6">
            <!-- <v-icon color="orange darken-2" size="120">mdi-alert-circle-outline</v-icon> -->
            <AccountWarningIcon :size="220" />
        </div>
        <v-card-text class="mt-0 pt-0  text-body-1 black--text d-flex justify-center">
            {{ msg }}
        </v-card-text>
        <v-btn class="pa-5 elevation-0 d-flex flex-column justify-center align-center" color="primary" width="180"
            @click="devuelveAccion()">
            <v-icon class="mr-2">mdi-camera-outline</v-icon>
            cargar foto
        </v-btn>
    </div>
</template>

<script>
import AccountWarningIcon from '@/assets/icons/account-warning-info.vue'

export default {
    name: 'CardRecordarFoto',
    components: {
        AccountWarningIcon,
    },
    data() {
        return {

        }
    },
    methods: {
        devuelveAccion() {
            const value = {
                tipo: 'fotocarnet',
                accion: 'cargar',
                cerrar: true // Nueva propiedad para indicar que debe cerrar el diálogo
            }
            this.$emit('cerrarDialogo', value)
        }
    },
    props: {
        msg: {
            type: String,
            default: 'Recordá subir tu foto de legajo',
        }
    }
}
</script>